import React from 'react';
import { useDragDrop } from '../../hooks/useDragDrop';

interface DropZoneProps {
  onFile?: (file: File) => void;
  accept?: string[];
  hint?: string;
}

const DropZone: React.FC<DropZoneProps> = ({
  onFile,
  accept = ['.js', '.ts', '.tsx', '.jsx', '.zip'],
  hint,
}) => {
  const { isDragging, droppedFile, dragProps, inputProps } = useDragDrop({ accept, onFile });

  return (
    <div
      {...dragProps}
      style={{
        border: `2px dashed ${isDragging ? 'var(--accent)' : 'var(--border)'}`,
        borderRadius: 'var(--radius-lg)',
        padding: 'clamp(24px, 5vw, 44px)',
        textAlign: 'center',
        background: isDragging ? 'var(--accent-dim)' : 'transparent',
        transition: 'all var(--transition-base)',
        cursor: 'pointer',
        position: 'relative',
        marginBottom: 20,
      }}
    >
      <input
        type="file"
        accept={accept.join(',')}
        style={{ position: 'absolute', inset: 0, opacity: 0, cursor: 'pointer' }}
        {...inputProps}
      />
      <div style={{ fontSize: 40, marginBottom: 12 }}>⬢</div>
      {droppedFile ? (
        <>
          <h3 style={{ fontSize: '0.95rem', fontWeight: 700, marginBottom: 4, color: 'var(--success)' }}>
            ✓ {droppedFile.name}
          </h3>
          <p style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>
            {(droppedFile.size / 1024).toFixed(1)} KB — Click or drop to replace
          </p>
        </>
      ) : (
        <>
          <h3 style={{ fontSize: '0.95rem', fontWeight: 700, marginBottom: 6 }}>
            Drop your React Native project
          </h3>
          <p style={{ fontSize: '0.8rem', color: 'var(--text-muted)', lineHeight: 1.55 }}>
            {hint ?? `Accepts ${accept.join(', ')} — or click to browse`}
          </p>
        </>
      )}
    </div>
  );
};

export default DropZone;
